import _ from "lodash";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import { asDragSource } from "../../components/dragAndDrop/DraggableComponent";
import FormEditableLabel from "../../components/form/FormEditableLabel";
import Icon from "../../components/interface/Icon";
import Identifier from "../../components/interface/Identifier";
import { SUBWAY_VIEW } from "../../constants/identifiers";
import { getModifierKeysForEvent } from "../../utils/getModifierKeys";
import { getLabelWithUntitled } from "../../utils/labelUtils";

const dragCallbacks = {
  beginDrag: _props => {
    // TODO: Do we want to set isDragging or similar...?
  },
  canDrag: props => {
    return props.allowDrag && Boolean(props.typeId);
  },
  getDragSourceParams: props => {
    return {
      itemId: props.itemId,
      itemType: props.typeId,
      sourceView: props.viewId,
      sourceViewType: SUBWAY_VIEW
    };
  },

  getPreviewElement: props => renderNodePreview(props)
};

const getInitialEditingStatus = (autoEditWhenBlank, isSelected, label, isActiveView) => {
  let result = false;
  //#!if iOS !== true
  result = isActiveView && autoEditWhenBlank && isSelected && (!label || label.trim() === getLabelWithUntitled());
  //#!endif
  return result;
};

const renderNodePreview = nodeProps => {
  const cloneProps = _.clone(nodeProps);
  cloneProps.selected = false;
  cloneProps.relativeLeft = 0;
  cloneProps.relativeTop = 0;
  cloneProps.onClick = null;
  cloneProps.onSuperClick = null;
  return renderNode(cloneProps, false);
};

const renderNode = useProps => {
  let classes = ["subwayThreadLabelBox", useProps.color];
  if (useProps.selected) {
    classes.push("selected");
  }

  const opacity = useProps.isDragging && !useProps.dragIsFromSameSource ? 0.5 : 1;

  const nodeStyle = {
    left: `${useProps.relativeLeft}px`,
    top: `${useProps.relativeTop}px`,
    width: `${useProps.width}px`,
    height: `${useProps.height}px`,
    opacity
  };

  const onClick = e => useProps.onClick(useProps.itemId, getModifierKeysForEvent(e), useProps.selected);

  const onDoubleClick = () => useProps.onDoubleClick();

  // const onChangeEditing = value => {
  //   this._isEditing = value;
  // };

  const onLabelChange = value => {
    useProps.onLabelChange([useProps.itemId], value);
  };

  const title = useProps.label;
  const placeholder = `${useProps.typeLabel} ${useProps.typeLabelDisplay}`;

  return (
    <div className={classes.join(" ")} style={nodeStyle} onClick={onClick} onDoubleClick={onDoubleClick}>
      <Icon icon={useProps.typeIcon} color={useProps.typeIconColor} />
      <span className="subwayThreadLabel">
        <FormEditableLabel
          value={useProps.label}
          displayValue={getLabelWithUntitled(useProps.label)}
          isEditing={getInitialEditingStatus(
            useProps.autoEditWhenBlank,
            useProps.selected,
            title,
            useProps.isActiveView
          )}
          placeholder={placeholder}
          multiline={false}
          allowNewLine={false}
          onChange={onLabelChange}
          // onChangeEditing={onChangeEditing}
        />
      </span>
      {useProps.initials ? <Identifier isAvatar={true} label={useProps.initials} color={useProps.color} /> : null}
    </div>
  );
};

class SubwayThreadLabelView extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return renderNode(this.props);
  }
}

SubwayThreadLabelView.propTypes = {
  viewId: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  id: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  color: PropTypes.string.isRequired,
  relativeLeft: PropTypes.number.isRequired,
  relativeTop: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  typeId: PropTypes.string,
  typeIcon: PropTypes.string,
  typeIconColor: PropTypes.string,
  initials: PropTypes.string,
  label: PropTypes.string,
  allowDrag: PropTypes.bool,
  onLabelChange: PropTypes.func.isRequired,
  isActiveView: PropTypes.bool.isRequired,
  autoEditWhenBlank: PropTypes.bool.isRequired,
  typeLabel: PropTypes.string.isRequired,
  typeLabelDisplay: PropTypes.string.isRequired,

  // From asDragSource
  isDragging: PropTypes.bool,
  dragIsFromSameSource: PropTypes.bool
};

export default asDragSource(SubwayThreadLabelView, SUBWAY_VIEW, dragCallbacks);
// export default SubwayThreadLabelView;
